(function() {
	"use strict";

	angular.module("swurveys.maker")
		.controller('navController', Handler)

	function Handler($scope, $routeParams, $location, authService, creditCardModal, paymentsConfigModal, referralModal) {

		var nav = this;
		var credential;

		authService.async()
			.then(function(data) {
				console.log(data);
				credential = data;
				$scope.user = credential;
				if (!credential.isLoggedIn()) {
					authService.relogin();
				}
			});

		nav.logout = function() {
			var answer = confirm("Are you sure you want to logout?");

			if (!answer) {
				event.preventDefault();
			}
			else {
				authService.logOut();
			}
		};

		nav.configureAutoTopOff = function() {
			var user = credential.user;
			user.identityId = nav.identityId;

			paymentsConfigModal.show(user).then(function(modal) {
				modal.element.modal();
				modal.close.then(function(confirm) {
					if (confirm === true) {

					}
				});
			});
		};

		nav.addCreditCard = function() {
			var identityId = credential.swurveys.identityId();
			creditCardModal.show(identityId, function(err, data) {
				if (err) {
					console.log(err);
				}
				else {
					$scope.$apply(function() {
						credential.user.hasPaymentInstrument = true;
						nav.configureAutoTopOff();
					});
				}
			});
		};

		nav.openReferralModal = function() {
			referralModal.show(credential.user).then(function(modal) {
				modal.element.modal();
			});
		};

	}

}());
